`use strict`;

import 'jquery-ui/ui/widgets/autocomplete.js';

import ShowDatepicker from '../libs/datepicker';

new ShowDatepicker(".js-div-datepicker");

class Registration {
  selectors = {
    checkDayTimeAvailability: `.js-availability-day-time`,
    cleanerRegistrationPostcode: '#cleaner-registration-postcode'
  };

  constructor() {
    this.checkDayTimeAvailability();
    this.initPostcodeAutocomplete();
  }

  initPostcodeAutocomplete() {
    console.log('this is called');
    let self = this;
    var cache = {};
    $(self.selectors.cleanerRegistrationPostcode).autocomplete({
      minLength: 1,
      source: async function( request, response ) {
          console.log('calling source');
        var term = request.term;
        if ( term in cache ) {
          response( cache[ term ] );
          return;
        }

        const res = await fetch(`https://api.postcodes.io/postcodes/${term}/autocomplete`);
        const { result } = await res.json();
        console.log('Res', result);
        response( result );
      },
      change: function (event, ui) {
        $(this).parent().find('.error').remove();
        if (!ui.item) {
          $(this).val('');
          $(this).after('<div class="error">Invalid Postcode.</div>');
        }
      }
    }).focus(function(){
      $(this).autocomplete("search");
    });
  }

  checkDayTimeAvailability () {

    $(this.selectors.checkDayTimeAvailability).on('click', function () {

      let dayTime = $(this).data('daytime');
      let availability = $('.js-availability');
      let status;

      if ($(this).data('checked') === 0){
        $(this).data('checked', 1);
        status = true;
      } else {
        $(this).data('checked', 0);
        status = false;
      }

      availability.each(function () {
        if ($(this).data('availability') !== dayTime) {
          return;
        }
        $(this).prop('checked', status);
      });

    });
  };
}

new Registration();